import React from 'react';
import { View, Animated } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { ErrorScreen, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';

import styles from './SubTrayError.Styles';

const renderDescription = (
  description,
  trayPlaceHolders,
  theme,
  accessibilityID,
  descriptionAnimation,
  isSubTrayDescriptionVisible,
) => {
  return (
    <Animated.View style={descriptionAnimation} testID={FrameworkTestKeys.subTrayErrorAnimatedView}>
      {isSubTrayDescriptionVisible ? (
        <VFText
          style={styles.descriptionStyle(theme)}
          i18nKey={description}
          placeHolders={trayPlaceHolders && trayPlaceHolders[description]}
          testKey={accessibilityID}
        />
      ) : null}
    </Animated.View>
  );
};

const SubTrayError = ({
  errorConfig,
  description,
  trayPlaceHolders,
  accessibilityID,
  descriptionAnimation,
  subTrayItem,
  isExpandedTray,
  images,
}) => {
  const theme = useTheme() || LightThemeColors;

  const { data, onTryAgainPress, isSubTrayDescriptionVisible } = errorConfig;
  const { errorMessage, tryAgainMessage, warningImage, tryAgainImage } = data;

  const { subTrayErrorMessage } = trayPlaceHolders;
  const errorMessagePlaceholders = [
    ContentManager.translate(subTrayErrorMessage || subTrayItem.title),
  ];

  return (
    <View
      style={styles.containerStyle(isExpandedTray)}
      testID={FrameworkTestKeys.SupTrayErrorDescription}
    >
      <View
        testID={FrameworkTestKeys.SupTrayErrorDescriptionView}
        style={styles.descriptionContainer(isExpandedTray)}
      >
        {renderDescription(
          description,
          trayPlaceHolders,
          theme,
          accessibilityID,
          descriptionAnimation,
          isSubTrayDescriptionVisible,
        )}
      </View>

      <ErrorScreen
        backgroundStyle={styles.errorBackground}
        iconName={warningImage}
        iconStyle={styles.warningIcon}
        text={errorMessage}
        textStyle={styles.errorMessage(theme)}
        tryButtonContainerStyle={styles.buttonContainer}
        textButton={tryAgainMessage}
        txtButtonStyle={styles.buttonText}
        iconButtonName={tryAgainImage}
        iconButtonStyle={styles.buttonIcon}
        onPress={onTryAgainPress}
        placeholders={errorMessagePlaceholders}
        extraInfo={subTrayItem}
        images={images}
        testID={FrameworkTestKeys.subTrayErrorErrorScreen}
      />
    </View>
  );
};

SubTrayError.defaultProps = {
  errorConfig: { data: {} },
  trayPlaceHolders: {},
  subTrayItem: {},
};

SubTrayError.propTypes = {
  errorConfig: PropTypes.object,
  description: PropTypes.string.isRequired,
  trayPlaceHolders: PropTypes.object,
  descriptionAnimation: ViewPropTypes.style,
  subTrayItem: PropTypes.object,
  isExpandedTray: PropTypes.bool,
  images: PropTypes.object,
  accessibilityID: PropTypes.string,
};

export default SubTrayError;
